import axios from 'axios'

export default {
  /**
   * Get parent by id
   * @param {integer} id
   * @returns {AxiosPromise<any>}
   */
  show (id) {
    return axios.get(`parent/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/parents.js